import React from 'react';

/** Bottom feedback: action messages + catalog sync (no duplicate Publish). */
export default function AdminShellFooter({ status, dirty, saving, catalogDbActive }) {
  const hasStatus = Boolean(String(status || '').trim());
  const showSync = dirty || saving || !catalogDbActive;

  if (!hasStatus && !showSync) return null;

  let syncLabel = 'Catalog up to date';
  if (saving) syncLabel = 'Saving catalog…';
  else if (dirty) syncLabel = 'Syncing changes…';
  else if (!catalogDbActive) syncLabel = 'Preview — not connected to live catalog';

  const statusFailed = hasStatus && status.toLowerCase().includes('fail');

  return (
    <div className="admin-shell-footer" role="status" aria-live="polite">
      <div className="container admin-shell-footer__inner">
        {showSync ? (
          <span className={`admin-shell-footer__sync${saving ? ' admin-shell-footer__sync--busy' : ''}`}>
            {syncLabel}
          </span>
        ) : (
          <span className="admin-shell-footer__sync admin-shell-footer__sync--idle" aria-hidden />
        )}
        {hasStatus ? (
          <span className={`admin-shell-footer__message${statusFailed ? ' admin-shell-footer__message--error' : ''}`}>
            {status}
          </span>
        ) : null}
      </div>
    </div>
  );
}
